import { MEETING_CODE_MAX_LENGTH } from '@constant/biz';
import { BOOL, MeetingItem, MeetingState } from '@tencent/wemeet-websdk-next';
import { gotoHomePage } from '@utils/navigate';
import { getQueryObj } from '@utils/url';
import { t } from 'i18next';
import { openDialog } from '@component/dialog';

/**
 *
 * 格式化会议号，用于展示
 *
 * 1. 增加空格
 * 2. 最多保留 11 位
 * @param meetingCode
 * @returns
 */
export const formatMeetingCode = (meetingCode: string): string => {
  // 会议号最多保留11位
  const cleanMeetingCode = meetingCode.replace(/\D/g, '').slice(0, MEETING_CODE_MAX_LENGTH);

  if (cleanMeetingCode.length < 9) {
    // 会议号小于9位，一般是join页用户主动输入
    // 对于这种情况转为 333 333 33这种3个数字一分割的形式
    // 同时需要额外处理结尾多余的空格
    return cleanMeetingCode.replace(/(\d{3})/g, '$1 ').replace(/\s+$/g, '');
  }

  if (cleanMeetingCode.length === 9 || cleanMeetingCode.length === 10) {
    return cleanMeetingCode.replace(/^(\d{3})(\d{3})(\d{3,})$/g, '$1 $2 $3');
  }

  if (cleanMeetingCode.length === 11) {
    return cleanMeetingCode.replace(/^(\d{3})(\d{4})(\d{4,})$/g, '$1 $2 $3');
  }
  return cleanMeetingCode;
};

export const checkIfCanJoinMeeting = (meetingInfoResult?: MeetingItem): boolean => {
  if (!meetingInfoResult) {
    return false;
  }

  const meetingState = meetingInfoResult.meeting_state;

  if (meetingState === MeetingState.CANCELED) {
    openDialog({
      title: t('加入会议失败'),
      content: t('会议已取消'),
      onOk: gotoHomePage,
    });

    return false;
  }

  if (meetingState === MeetingState.ENDED) {
    openDialog({
      title: t('加入会议失败'),
      content: t('会议已结束'),
      onOk: gotoHomePage,
    });

    return false;
  }

  if (meetingState === MeetingState.RECYCLED) {
    openDialog({
      title: t('加入会议失败'),
      content: t('会议已回收'),
      onOk: gotoHomePage,
    });

    return false;
  }

  const { meeting_lock: meetingLock } = meetingInfoResult.meeting_lock_settings;
  if (meetingLock === BOOL.true) {
    openDialog({
      title: t('加入会议失败'),
      content: t('当前会议已被锁定，无法加入\n如需加入，请联系会议主持人'),
      onOk: gotoHomePage,
    });

    return false;
  }

  // 是否是腾讯企业用户创建的会议
  // 临时需求
  // FIXME: 由于腾讯企业 appId 和 voov 的 trtc sdk_app_id 一样，所以这么判断
  const isTencentMeeting = meetingInfoResult.creator['@app_id'] === process.env.REACT_APP_SDK_APP_ID;
  if (isTencentMeeting && getQueryObj().debug !== '1') {
    openDialog({
      title: t('加入会议失败'),
      content: (
        <div>
          <p>{t('此会议暂不支持通过浏览器加入，请使用VooV Meeting客户端参会')} </p>
          <a className="text-btn--download" href="https://voovmeeting.com/download-center.html?from=1001">
            {t('下载 VOOV Meeting')}
          </a>
        </div>
      ),
      onOk: gotoHomePage,
    });
    return false;
  }

  return true;
};

export const handleNormalError = (message: string) => {
  openDialog({
    dialogId: 'normalError',
    title: t('错误'),
    okText: t('确定'),
    content: message,
    onOk: gotoHomePage,
  });
};
